import styled from "styled-components";

export const H1 = styled.div`
  font-size: 32px;
  font-weight: bold;
  letter-spacing: 0.9px;
  color: #1070b6;
  margin-bottom: 20px;
`;

export const H2 = styled.div`
  font-size: 26px;
  font-weight: bold;
  letter-spacing: 0.9px;
  color: #1070b6;
  margin-bottom: 20px;
`;

export const H3 = styled.div`
  font-size: 18px;
  font-weight: bold;
  letter-spacing: 0.45px;
  color: #1070b6;
  margin-bottom: 20px;
`;

export const H4 = styled.div`
  font-size: 14px;
  font-weight: bold;
  letter-spacing: 0.35px;
  color: #1070b6;
`;

export const SectionTitle = styled.div`
  color: #1070b6;
  font-weight: bold;
  font-size: 36px;
  text-align: left;
  transform: scaleY(0.99);
`;
